import * as Commons from "oc-commons/Commons";

type ClassConstructor = {
  CLASS_NAME?: string;
  new (...args: any[]): any;
};

const clazzMap = Commons.cache(() => {
  const classes = Commons.slurpDirectory(require.context(".", true, /\.(ts|tsx|js|jsx)$/));
  const classMap = {};
  Object.values(classes)
    .filter((clazz) => clazz?.CLASS_NAME)
    .forEach((clazz) => (classMap[clazz.CLASS_NAME] = clazz));
  return classMap;
}) as () => Record<string, ClassConstructor>;

export function createClass<T = any>(className: string, ...args: any[]): T {
  const map = clazzMap();
  const clazz = map[className];
  if (!clazz) {
    throw new Error(
      `createClass: class "${className}" not found (does it have a static property CLASS_NAME)?`
    );
  }
  return new clazz(...args) as T;
}
